<template>
  <div class="news-detail">
    <!-- 头部导航组件 -->
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <!-- pc端 -->
    <section class="news-detail-center" v-if="img">
      <Breadcrumb :fromPath="fromPath" />
      <!-- <div class="news-detail-center-top">
        <div class="news-detail-center-top-left">
          <img
            :src="img"
            alt=""
          />
        </div>
      
      </div> -->
      <div class="news-detail-center-content">
        <!-- <div class="title">
          {{ data.title }}
        </div>
        <div class="author">
          <div>作者：</div>
          <div>{{ data.author }}</div>
          <div class="author-date">发布于：</div>
          <div>{{ moment(data.createdate).format('YYYY-MM-DD HH:mm:ss') }}</div>
          <div class="author-number">浏览（{{ data.pvCount }}）</div>
        </div> -->
        <div class="message" >
                    <img
            :src="img"
            alt="" style="width:100%;height:100%"
          />
        </div>
      </div>
    </section>
    <!-- 移动端 -->
    <section class="news-detail-center-mobile" v-if="img">
      <div class="content">
        <!-- <div class="title">
          {{ data.title }}
        </div>
        <div class="author-wrap">
          <div class="left tag-list" v-if="data.tags"> 
            <span v-for="tag in data.tags.split(',')" :key="tag" class="tag-item" @click="gotoList('tag', tag)">{{ tag }}</span>
          </div>
          <div class="right">
            <template  v-if="data.author">
            <div class="author">作者：{{ data.author }}</div>
            </template>
            <div>
              <span class="number">{{ data.pvCount }}次浏览</span>
              <span class="date">{{ moment(data.createdate).format('YYYY-MM-DD') }}</span>
            </div>
          </div>
        </div> -->

        <div class="message">
           <img
            :src="img"
            alt="" style="width:100%;height:100%"
          />
        </div>
      </div>
    </section>
    <footer-cmp></footer-cmp>
  </div>
</template>
<script>
import headerCmp from "@/components/common/header.vue";
import menuCmp from "@/components/common/navMenu.vue";
import footerCmp from "@/components/common/footer.vue";
import Breadcrumb from "./components/Breadcrumb.vue";

import moment from "moment";
export default {
  data() {
    return {
      newsId: this.$route.query.id,
      fromPath: "",
      data: null,
      img:"",
    };
  },
  components: {
    headerCmp,
    menuCmp,
    footerCmp,
    Breadcrumb,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromPath = from.path;
    });
  },
  created(){
            this.img = this.$route.params.item.img;
          console.log('created',this.img,this.$route.params); 
  },
  methods: {
    moment,
    // getDetail(){
    //   getNewsDetail({ id: this.newsId }).then(res=>{
    //     this.data = res.data;
    //   })
    // },
    // gotoList(type, val){
    //   this.$router.push(`/more?type=${type}&val=${val}`);
    // }
  },
  watch: {
      $route() {
          this.img = this.$route.params.item.img;
          console.log('routeroute',this.img); 
          // this.getDetail();
          // this.getList();
      }
  },
  mounted(){ 
   // this.getDetail();
  },
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 961px) {
  .news-detail {
    font-size: 14px;
    width: 100%;
    height: 100%;

    &-center {
      width: 1200px;
      margin: 0 auto;

      &-top {
        margin-bottom: 24px;
        display: flex;

        &-left {
          img {
            width: 790px;
            height: 427px;
            margin-right: 40px;
          }
        }

        &-right {
          .classify {
            .title {
              font-size: 24px;
              font-weight: 500;
              color: #da5351;
              line-height: 33px;
              margin-bottom: 20px;
            }

            ul {
              margin-bottom: 24px;

              li {
                cursor: pointer;
                &::before {
                  content: "> ";
                }

                font-size: 16px;
                font-weight: 500;
                color: #333333;
                line-height: 22px;
                margin-bottom: 16px;
              }
            }
          }

          .tag {
            .title {
              font-weight: 500;
              color: #da5351;
              line-height: 33px;
              margin-bottom: 20px;
              font-size: 24px;
            }

            ul {
              display: flex;
              flex-wrap: wrap;

              li {
                padding: 8px 14px;
                cursor: pointer;
                border-radius: 30px;
                border: 1px solid #da5351;
                font-size: 14px;
                font-weight: 400;
                color: #da5351;
                text-align: center;
                margin-right: 10px;
                margin-bottom: 12px;
                max-width: 140px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }

      &-content {
        width: 790px;

        .title {
          font-size: 34px;
          font-weight: 500;
          color: #333333;
          line-height: 46px;
          margin: 24px 0px 20px 0px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .author {
          display: flex;
          margin-bottom: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 20px;

          &-date {
            margin-left: 10px;
          }

          &-number {
            margin-left: 10px;
          }
        }

        .message {
          font-size: 16px;
          font-weight: 400;
          color: #454545;
          line-height: 24px;
          margin-bottom: 80px;
        }
      }
    }
  }

  .news-detail-center-mobile {
    display: none;
  }
}

@media screen and (max-width: 960px) {
  .news-detail-center {
    display: none;
  }

  .news-detail-center-mobile {
    height: 100%;
    position: relative;
    padding-top: 0.56rem;
    .content {
      padding: 0.24rem 0.16rem 0.4rem;
      min-height: calc(100vh - var(--nav-menu-height) - var(--foot-height));
      box-sizing: border-box;
    }
    .title {
      font-size: 0.24rem;
      font-weight: 500;
      color: #454545;
      line-height: 0.3rem;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .author-wrap {
      margin: 0.1rem 0px 0.16rem;
      .left {
        font-size: 0.12rem;
        font-weight: 500;
      }
      .tag-item{
        display: inline-block;
        color: #cc3b3f;
        line-height: 0.16rem;
        padding: 0.04rem 0.1rem;
        background: rgba($color: #cc3b3f, $alpha: 0.2);
        border-radius: 0.04rem;
        margin-right: .1rem;
        margin-bottom: .1rem
      }
      .right {
        display: flex;
        font-size: 0.12rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.14rem;
        justify-content: space-between;
        .number {
          margin-right:  .1rem;
          display: inline-block;
        }
      }
    }
    .content-img {
      width: 100%;
      height: 1.67rem;
      object-fit: cover;
    }
    .message {
      font-size: 0.16rem;
      font-weight: 400;
      color: #454545;
      line-height: 0.22rem;
    }
  }
}
</style>